function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "dj0dm1f1ha",
  d: "M4.173 2.783h4.186c.698-.007 1.293.505 1.391 1.196.188 1.427.54 2.841 1.048 4.202.193.511.07 1.084-.312 1.47l-1.761 1.762c-.443.443-.535 1.127-.226 1.672 2.105 3.7 5.169 6.765 8.87 8.87.544.309 1.228.216 1.671-.227l1.767-1.767c.381-.376.954-.498 1.463-.307 1.363.509 2.777.861 4.217 1.05.687.098 1.201.705 1.184 1.411v4.209c.001.397-.163.771-.451 1.036-.289.265-.676.396-1.066.36-4.04-.438-7.945-1.828-11.375-4.052-3.2-2.034-5.904-4.738-7.93-7.927-2.24-3.456-3.63-7.38-4.063-11.463-.033-.368.097-.753.36-1.042.264-.288.636-.453 1.027-.453z"
}), /*#__PURE__*/React.createElement("path", {
  id: "srdu093xtb",
  d: "M1.545.009c6.461.717 11.564 5.814 12.29 12.274.086.764-.464 1.452-1.227 1.538-.764.086-1.453-.464-1.538-1.227-.205-1.82-.843-3.503-1.81-4.947-1.78-2.657-4.673-4.5-8.022-4.873C.474 2.69-.076 2.001.008 1.238.089.528.687.003 1.384 0l.162.009z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-557.000000, -326.000000) translate(509.000000, 215.710281) translate(48.000000, 111.000000) translate(0.000000, 1.391138)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4F9900",
  fillRule: "nonzero",
  d: "M8.332 0h-4.16c-1.174.001-2.29.495-3.08 1.36-.79.865-1.18 2.023-1.075 3.19.482 4.54 2.02 8.88 4.49 12.694 2.238 3.523 5.235 6.52 8.769 8.765 3.785 2.455 8.105 3.992 12.602 4.48 1.196.109 2.357-.284 3.223-1.078.866-.795 1.357-1.918 1.352-3.093V22.15c.052-2.084-1.491-3.906-3.59-4.202-1.244-.164-2.453-.466-3.617-.9l-.271-.091c-1.452-.435-3.04-.047-4.13 1.031l-1.003 1-.165-.103c-2.44-1.588-4.521-3.669-6.109-6.109l-.105-.166.996-.996c1.152-1.165 1.518-2.884.945-4.41-.433-1.16-.734-2.37-.897-3.601C12.212 1.515 10.427-.02 8.332 0z"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#6DD400",
  fillRule: "nonzero",
  xlinkHref: "#dj0dm1f1ha"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#6DD400",
  fillRule: "nonzero",
  d: "M18.027 6.69c.147-.754.877-1.246 1.632-1.099 3.335.65 5.944 3.26 6.594 6.595.148.754-.345 1.485-1.099 1.632-.754.147-1.485-.345-1.632-1.1-.434-2.223-2.172-3.962-4.396-4.396-.754-.147-1.247-.878-1.1-1.632z",
  transform: "translate(-557.000000, -326.000000) translate(509.000000, 215.710281) translate(48.000000, 111.000000)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-557.000000, -326.000000) translate(509.000000, 215.710281) translate(48.000000, 111.000000) translate(18.000750, 0.000000)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#6DD400",
  fillRule: "nonzero",
  xlinkHref: "#srdu093xtb"
}))))));

var SvgIconTelefon = function SvgIconTelefon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTelefon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-telefon.ab30826e.svg";
export { ForwardRef as ReactComponent };